angular.module('unergie.main')
.controller('metaInvoicesB2GCtrl', ($scope, $state, DataAccess, NgTableParams, BoFeaturesService, FilterMapping, SocketFactory, DownloadService, EventProcessorService,
    DataAccessSearch, ApiBilling, ApiUser, ApiAdmin, AlertManager, Sequentializer, TableGeneratorService, ErrorCatcher, clientMode, ModalService, AuthService, UserNotificationService) => {
    $scope.isActive = (state) => $state.is(state)
    $scope.showTools = !BoFeaturesService.get('isEnvProd')
    $scope.clientMode = clientMode
    $scope.canCreatePenalty = BoFeaturesService.isFeatureOn('canCreatePenalty')
    $scope.billingAdmin = BoFeaturesService.isFeatureOn('billingAdmin')
    $scope.canMetaMassOperation = BoFeaturesService.isFeatureOn('canMetaMassOperation')
    $scope.canUpdateMetaExternalStatus = BoFeaturesService.isFeatureOn('canUpdateMetaExternalStatus')
    $scope.hasCategoriesPageAccess = AuthService.getSubMenus().includes('categories')
    const isEnvProd = BoFeaturesService.get('isEnvProd')

    $scope.invoiceStatuses = FilterMapping.invoiceStatuses
    $scope.metaInvoiceTypes = FilterMapping.metaInvoiceTypes
    $scope.invoiceStatusesClientMode = [{ id: '50', title: 'Facturée' }, { id: '75', title: 'Extournée' }]
    $scope.invoiceStatusesFilter = {
        50: 'Facturée',
        75: 'Extournée',
    }

    $scope.notNullFilter = [{ id: '!<null>', title: 'Oui' }, { id: '<null>', title: 'Non' }]

    $scope.chorusStatuses = (external_status) => {
        switch (external_status) {
            case 'MISE_EN_PAIEMENT': return 'green'
            case 'A_RECYCLER':
            case 'REJETEE': return 'red'
            case 'NON_SOUMISE': return ''
            default:
                return 'orange'
        }
    }

    SocketFactory.join('BO_metaInvoicesB2G', $scope)

    $scope.chorusFields = {
        label: {
            label: (i) => {
                switch (i.type) {
                    case 'REVERSAL':
                        return `<span class="red">Attention ! Les factures de reversement ne s'envoient pas normalement à CHORUS, validation nécessaire par Florence.<br>` +
                        `(Envoi à CHORUS seulement si la facture reversée est référencée comme payée chez CHORUS)</span>`
                    default:
                        return ''
                }
            },
            type: 'label',
        },
        manually: {
            hidden: (t) => t.asis || t.skipDetails,
            label: 'La facture a DÉJÀ été déposée à la main dans CHORUS',
            type: 'checkbox',
        },
        asis: {
            hidden: (t) => t.manually || t.skipDetails,
            label: 'Ne pas recalculer les montants pour CHORUS',
            type: 'checkbox',
        },
        skipDetails: {
            hidden: (t) => t.manually || t.asis,
            label: 'Ne pas envoyer les lignes de TVA',
            type: 'checkbox',
        },
    }

    $scope.reversalDoneFields = {
        label: {
            label: `<span class="red">Attention ! Les factures de reversement ne doivent être mises à DONE que si la facture initiale n'a pas été payée dans CHORUS, ` +
            `sinon : envoyer la reversion à CHORUS</span>`,
            type: 'label',
        },
    }

    $scope.reversalFields = {
        label: {
            label: (i) => (i.id_penalty ? `<span class="red">Attention la facture a donné lieu à une pénalité (id: ${i.id_penalty}), pensez à gérer son annulation.</span>` : ''),
            type: 'label',
        },
    }

    $scope.boolFilter = [{ id: true, title: 'Oui' }, { id: false, title: 'Non' }]

    const COLUMNS_CLIENT_HIDDEN = [
        'selector',
        'category.organization',
        'id_invoice_odoo',
        'error_code',
        'facturx_xml_path',
        'facturx_pdf_path',
    ]

    const COLUMNS_CLIENT_ADDED = {
        id: { label: 'ID', mode: 'hidden' },
        id_category: { label: 'ID Paquet', mode: 'hidden' },
        external_id: { label: 'Chorusé', mode: 'hidden' },
        due_date: { label: 'Date dûe', mode: 'search_date', translateCsv: 'date_due' },
    }

    $scope.metaInvoices = {
        refreshing: false,
        show: {},
        counts: [10, 25, 50, 100],
        columns: _.assign(_.omit({
            'selector': { label: 'Sel.', mode: 'filter_only' },
            'id': { label: 'ID', mode: 'search_operator', mandatory: true },
            'pdf_path': { label: 'PDF', mode: 'search_wildcard', csvIgnore: true },
            'xlsx_path': { label: 'XLSX', mode: 'search_wildcard', csvIgnore: true },
            'zip_path': { label: 'ZIP', mode: 'search_wildcard', csvIgnore: true },
            'facturx_xml_path': { label: 'Xml FacturX', mode: 'search_wildcard', csvIgnore: true, isVisible: false },
            'facturx_pdf_path': { label: 'PDF FacturX', mode: 'search_wildcard', csvIgnore: true, isVisible: false },
            'category.organization': { label: 'Org.', mode: 'search_wildcard' },
            'id_category': { label: 'ID Paquet', mode: 'search_operator', mandatory: true },
            'category.name': { label: 'Paquet facturier', mode: 'search_wildcard', translateCsv: 'paquet_facturier' },
            'type': { label: 'Type', mode: 'search_wildcard' },
            'status': { label: 'Status', mode: 'search_operator', translateCsv: 'statut' },
            'category.account.brand': { label: 'Compte', mode: 'search_wildcard', translateCsv: 'compte' },
            'invoice_number': { label: 'N° Facture', mode: 'search_wildcard', translateCsv: 'numero' },
            'invoice_date': { label: 'Date Facture', mode: 'search_date', translateCsv: 'date_creation' },
            'period_start_date': { label: 'Début', mode: 'search_date', translateCsv: 'date_debut_periode' },
            'period_end_date': { label: 'Fin', mode: 'search_date', translateCsv: 'date_fin_periode' },
            'total_cons': { label: 'Conso kWh', mode: 'search_operator', translateCsv: 'total_cons' },
            'total': { label: 'Montant', mode: 'search_operator' },
            'total_cons_valued': { label: 'Consommation', mode: 'search_operator', translateCsv: 'total_consommation' },
            'total_taxes': { label: 'Taxe', mode: 'search_operator' },
            'total_vat': { label: 'TVA', mode: 'search_operator', translateCsv: 'total_tva' },
            'preparation_result': { label: 'Résultats intermédiaires', mode: 'hidden' },
            'error_code': { label: 'Code erreur', mode: 'search_wildcard' },
            'category.send_to_chorus': { label: 'A envoyer à CHORUS', mode: 'hidden' },
            'category.block_auto_run': { label: 'A envoyer à CHORUS', mode: 'hidden' },
            'accounting_amount': { label: 'Montant envoyé à CHORUS', mode: 'hidden' },
            'external_id': { label: 'Chorusé', mode: 'search_wildcard' },
            'id_invoice_odoo': { label: 'Odoo', mode: 'search_wildcard' },
            'reversal_of': { label: 'Extourne', mode: 'hidden' },
            'external_status': { label: 'Statut Chorus', mode: 'search_wildcard', translateCsv: 'statut_chorus' },
            'id_penalty': { label: 'Facture de pénalité', mode: 'hidden' },
            'total_paid': { label: 'Montant payé', mode: 'search_operator' },
        }, clientMode ? COLUMNS_CLIENT_HIDDEN : []), clientMode ? COLUMNS_CLIENT_ADDED : {}),
    }

    $scope.isInvoice = (invoice) => invoice.type === 'INVOICE'
    $scope.isReversal = (invoice) => invoice.type === 'REVERSAL'
    $scope.isPenalty = (invoice) => invoice.type === 'PENALTY'
    $scope.isCompensation = (invoice) => invoice.type === 'COMPENSATION'
    $scope.simulable = (invoice) => [11, 40, 501, 90, 92, 93, 99].includes(invoice.status) && ($scope.isInvoice(invoice) || $scope.isCompensation(invoice))
    $scope.cancellable = (invoice) => [0, 1, 11, 12, 20, 21, 40, 501, 90, 91, 92, 99].includes(invoice.status) && !invoice.invoice_number && $scope.isInvoice(invoice)
    $scope.valuable = (invoice) => [0, 11, 12, 20, 21, 40, 501, 90, 91, 92, 93, 99].includes(invoice.status) && $scope.isInvoice(invoice)
    $scope.runnable = (invoice) => ([54, 501, 93].includes(invoice.status) || ([92, 93].includes(invoice.status) && invoice.invoice_number))
        && ($scope.isInvoice(invoice) || $scope.isCompensation(invoice))
    $scope.sendable = (invoice) => [54].includes(invoice.status) && invoice.category.send_to_chorus
    $scope.reversable = (invoice) => [50, 54].includes(invoice.status) && ($scope.isInvoice(invoice) || $scope.isPenalty(invoice) || $scope.isCompensation(invoice))
    $scope.chorusRequestable = (invoice) => !!invoice.external_id
    $scope.reversalDoneable = (invoice) => $scope.isReversal(invoice) && [54].includes(invoice.status)
    $scope.doneable = (invoice) => !$scope.isReversal(invoice) && [54].includes(invoice.status) && !invoice.category.send_to_chorus
    $scope.penaltyable = (invoice) => $scope.isInvoice(invoice) && [50].includes(invoice.status) && !invoice.id_penalty

    $scope.processing = (invoice) => _.some([
        $scope.massOperating,
        invoice.simulating,
        invoice.valuating,
        invoice.running,
        invoice.cancelling,
        invoice.sending,
        invoice.chorusing,
        invoice.reversing,
        invoice.doneing,
        invoice.penaltying,
        invoice.toggling,
    ])

    $scope.toggleSelected = function (invoice, e) {
        e.preventDefault()
        e.stopPropagation()
        invoice.selected = !invoice.selected
    }

    $scope.selectAll = () =>
        _.forEach($scope.metaInvoices.instance.data, (c) => {
            c.selected = true
        })

    $scope.deSelectAll = () =>
        _.forEach($scope.metaInvoices.instance.data, (c) => {
            c.selected = false
            return true
        })

    $scope.getValuables = () =>
        _.map(_.filter($scope.metaInvoices.instance.data, (i) => i.selected && $scope.valuable(i)), 'id')

    $scope.getSimulables = () =>
        _.map(_.filter($scope.metaInvoices.instance.data, (i) => i.selected && $scope.simulable(i)), 'id')

    $scope.getSimulableCompensations = () =>
        _.map(_.filter($scope.metaInvoices.instance.data, (i) => i.selected && $scope.simulable(i) && $scope.isCompensation(i)), 'id')

    $scope.getSimulableNotCompensations = () =>
        _.map(_.filter($scope.metaInvoices.instance.data, (i) => i.selected && $scope.simulable(i) && !$scope.isCompensation(i)), 'id')

    $scope.getRunnables = () =>
        _.map(_.filter($scope.metaInvoices.instance.data, (i) => i.selected && $scope.runnable(i) && !i.category.block_auto_run), 'id')

    $scope.getRunnableCompensations = () =>
        _.map(_.filter($scope.metaInvoices.instance.data, (i) => i.selected && $scope.runnable(i) && !i.category.block_auto_run && $scope.isCompensation(i)), 'id')

    $scope.getRunnableNotCompensations = () =>
        _.map(_.filter($scope.metaInvoices.instance.data, (i) => i.selected && $scope.runnable(i) && !i.category.block_auto_run && !$scope.isCompensation(i)), 'id')

    $scope.getReversalDoneables = () =>
        _.filter($scope.metaInvoices.instance.data, (i) => i.selected && $scope.isReversal(i) && $scope.reversalDoneable(i) && !$scope.processing(i))

    $scope.getDoneables = () =>
        _.filter($scope.metaInvoices.instance.data, (i) => i.selected && $scope.doneable(i) && !$scope.processing(i))

    $scope.getSendablesInvoices = () => _.filter($scope.metaInvoices.instance.data, (i) => i.selected && $scope.sendable(i))

    $scope.getReversables = () =>
        _.map(_.filter($scope.metaInvoices.instance.data, (i) => i.selected && $scope.reversable(i)), 'id')

    $scope.getSynchronizables = () =>
        _.map(_.filter($scope.metaInvoices.instance.data, (i) => i.selected && $scope.chorusRequestable(i)), 'id')

    $scope.getCancellablesInvoices = () =>
        _.filter($scope.metaInvoices.instance.data, (i) => i.selected && $scope.cancellable(i))

    $scope.getPenaltyablesInvoices = () =>
        _.filter($scope.metaInvoices.instance.data, (i) => i.selected && $scope.penaltyable(i))

    $scope.getSelectedNumber = () => _.countBy($scope.metaInvoices.instance.data, 'selected').true || 0

    const fetchMetaInvoiceInvoices = (invoice) => {
        return ApiBilling.fetchMetaInvoiceInvoices({ id: invoice.id }).$promise.then((result) => {
            invoice.invoiceCount = result.length
            invoice.invoicesTP = new NgTableParams({ count: 12 }, {
                counts: [],
                dataset: result,
            })
        })
        .catch(ErrorCatcher)
    }

    $scope.refreshInvoice = function (i) {
        const refreshes = []
        refreshes.push(fetchMetaInvoiceInvoices(i))
        i.refreshing = true
        return Promise.all(refreshes).then(() => {
            i.fetched = true
            i.refreshing = false
        })
    }

    $scope.toggleExpand = function (invoice) {
        if (!invoice.refreshing) {
            invoice.expanded = !invoice.expanded
            if (!invoice.fetched) {
                $scope.refreshInvoice(invoice)
            }
        }
    }

    EventProcessorService.register('META_STATUS_CHANGED', 'ALL', $scope, (event) => {
        UserNotificationService.addNotif({ msg: event.title })
        const meta = _.find($scope.metaInvoices.instance.data, { id: event.metaInvoiceId })
        if (meta) {
            return DataAccessSearch({ offset: 0, columns: _.without(Object.keys($scope.metaInvoices.columns), 'selector') })
            .searchPaginated({ resource: 'meta-invoices-light', id: event.metaInvoiceId }).$promise
            .then((dataUpdate) => {
                if (dataUpdate && dataUpdate.results && dataUpdate.results.length) {
                    _.assign(meta, dataUpdate.results[0])
                }
            })
        }
    })

    // TEST READINGS
    $scope.categoryPayload = {
        id_category: '',
        period_end_date: moment().add(-1, 'month').endOf('month'),
    }

    $scope.categoryFields = {
        id_category: {
            label: 'IDs paquets facturiers (<id1>,<id2>)',
            type: 'text',
        },
        period_end_date: {
            label: 'Date',
            type: 'date',
        },
    }

    $scope.revaluateTemplate = {
        revaluate: false,
    }

    $scope.revaluateFields = {
        revaluate: {
            label: 'Revaloriser toutes les factures (même celles déja valo)',
            type: 'checkbox',
        },
    }

    $scope.regenTemplate = {
        regen: false,
    }

    $scope.regenFields = {
        regen: {
            label: 'Régénérer tous les PDF (même ceux déjà générés)',
            type: 'checkbox',
        },
    }

    // CALLS
    $scope.createMetaForCategory = () => {
        if ($scope.categoryPayload.id_category) {
            $scope.creatingMeta = true
            return ApiBilling.createMetaInvoice({
                categories: _.map($scope.categoryPayload.id_category.split(','), (id) => Number(id.trim())),
                endDate: moment($scope.categoryPayload.period_end_date).format('YYYY-MM-DD'),
            }).$promise.then((result) => {
                AlertManager.success('Ok')
            })
            .catch(ErrorCatcher)
            .finally(() => {
                $scope.refreshInvoices()
                $scope.creatingMeta = false
            })
        }
    }

    $scope.valuate = (invoice) => {
        if ($scope.processing(invoice)) {
            return
        }
        if ($scope.valuable(invoice)) {
            invoice.valuating = true
            return ApiBilling.valuateMetaInvoice({ id_invoice: invoice.id }, { reprocessAll: $scope.revaluateTemplate.revaluate }).$promise.then((result) => {
                AlertManager.success(`Valorisation lancée`)
            })
            .catch(ErrorCatcher)
            .finally(() => {
                invoice.valuating = false
                $scope.refreshInvoices()
            })
        }
    }

    $scope.simulate = (invoice) => {
        if ($scope.processing(invoice)) {
            return
        }
        if ($scope.simulable(invoice)) {
            invoice.simulating = true
            if ($scope.isCompensation(invoice)) {
                return ApiBilling.simulateCompensationsMeta({ id_meta_invoice: invoice.id }, {}).$promise.then((result) => {
                    invoice.pdf_path = result.pdf_path
                    AlertManager.success(`Simulation (re)générée`)
                    $scope.dl(invoice, 'pdf')
                })
                .catch(ErrorCatcher)
                .finally(() => {
                    invoice.simulating = false
                    $scope.refreshInvoices()
                })
            }
            return ApiBilling.prepareMetaInvoice({ id_invoice: invoice.id, regen: $scope.regenTemplate.regen }, {}).$promise.then((result) => {
                AlertManager.success('Simulation lancée !')
            })
            .catch(ErrorCatcher)
            .finally(() => {
                invoice.simulating = false
                $scope.refreshInvoices()
            })
        }
    }

    $scope.run = (invoice) => {
        if ($scope.processing(invoice)) {
            return
        }
        invoice.running = true
        if ($scope.isCompensation(invoice)) {
            return ApiBilling.runCompensationsMeta({ id_meta_invoice: invoice.id }, {}).$promise.then((result) => {
                AlertManager.success('Lancement lancé')
            })
            .catch(ErrorCatcher)
            .finally(() => {
                invoice.running = false
                $scope.refreshInvoices()
            })
        }
        return ApiBilling.runMetaInvoice({ id_invoice: invoice.id, regen: $scope.regenTemplate.regen }, {}).$promise.then((result) => {
            AlertManager.success('Lancement lancé')
        })
        .catch(ErrorCatcher)
        .finally(() => {
            invoice.running = false
            $scope.refreshInvoices()
        })
    }

    $scope.reverse = (invoice) => {
        if ($scope.processing(invoice)) {
            return
        }
        invoice.reversing = true
        return ApiBilling.revertMetaInvoice({ id_invoice: invoice.id }, {}).$promise.then((result) => {
            AlertManager.success('Reversement OK')
        })
        .catch(ErrorCatcher)
        .finally(() => {
            invoice.reversing = false
            $scope.refreshInvoices()
        })
    }

    $scope.penaltyTemplate = {
        force: false,
    }

    $scope.penaltyFields = {
        force: {
            hidden: () => isEnvProd,
            label: 'Forcer la création',
            type: 'checkbox',
        },
    }

    $scope.createPenalty = (invoice, doNotRefresh = false) => {
        if ($scope.processing(invoice)) {
            return
        }
        invoice.penaltying = true
        return ApiBilling.createPenalty({ id_invoice: invoice.id, force: $scope.penaltyTemplate.force }, {}).$promise.then((result) => {
            AlertManager.success('Pénalité créée')
        })
        .catch(ErrorCatcher)
        .finally(() => {
            invoice.penaltying = false
            if (!doNotRefresh) {
                $scope.refreshInvoices()
            }
        })
    }

    $scope.sendToChorus = (invoice, doNotRefresh = false) => {
        if ($scope.processing(invoice)) {
            return
        }
        invoice.sending = true
        const params = { id_meta_invoice: invoice.id, asis: invoice.asis, skipDetails: invoice.skipDetails }
        return ApiUser[invoice.manually ? 'metaInvoiceChorusedManually' : 'sendMetaInvoiceToChorus'](params, {}).$promise
        .then((result) => {
            AlertManager.success('Envoi OK')
        })
        .catch(ErrorCatcher)
        .finally(() => {
            invoice.sending = false
            if (!doNotRefresh) {
                $scope.refreshInvoices()
            }
        })
    }

    $scope.cancelInvoice = (invoice, doNotRefresh = false) => {
        if ($scope.processing(invoice)) {
            return
        }
        invoice.cancelling = true
        return DataAccess.cancelMetaInvoice({ id_invoice: invoice.id }).$promise.then((result) => {
            AlertManager.success('Annulation OK')
        })
        .catch(ErrorCatcher)
        .finally(() => {
            invoice.cancelling = false
            if (!doNotRefresh) {
                $scope.refreshInvoices()
            }
        })
    }

    $scope.invoiceReversalDone = (invoice) => {
        if ($scope.processing(invoice)) {
            return
        }
        invoice.doneing = true
        return ApiUser.invoiceReversalDone({ id: invoice.id }, {}).$promise.then((result) => {
            AlertManager.success('Facture de reversement mise à DONE, et mail envoyé')
        })
        .catch(ErrorCatcher)
        .finally(() => {
            invoice.doneing = false
            $scope.refreshInvoices()
        })
    }

    $scope.invoiceDone = (invoice) => {
        if ($scope.processing(invoice)) {
            return
        }
        invoice.doneing = true
        return ApiUser.invoiceDone({ id: invoice.id }, {}).$promise.then((result) => {
            AlertManager.success('Facture mise à DONE, et mail envoyé')
        })
        .catch(ErrorCatcher)
        .finally(() => {
            invoice.doneing = false
            $scope.refreshInvoices()
        })
    }

    $scope.checkChorusStatus = (invoice, e) => {
        e.preventDefault()
        e.stopPropagation()
        invoice.chorusing = true
        return ApiUser.checkChorusStatus({ id_meta_invoice: invoice.id }).$promise.then((result) => {
            AlertManager.success(`Status CHORUS : "${result.facture.statutFacture}"`)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            invoice.chorusing = false
        })
    }

    $scope.regenPDF = (invoice, e) => {
        if (e) {
            e.preventDefault()
            e.stopPropagation()
        }
        invoice.regeneratingPdf = true
        return ApiBilling.regenMetaPDF({ id_meta_invoice: invoice.id }, {}).$promise.then((result) => {
            invoice.pdf_path = result.pdf_path
            AlertManager.success(`Facture régénérée`)
            $scope.dl(invoice, 'pdf')
        })
        .catch(ErrorCatcher)
        .finally(() => {
            invoice.regeneratingPdf = false
        })
    }

    // DL LINK
    $scope.dl = (invoice, type, e) => {
        if (e) {
            e.preventDefault()
            e.stopPropagation()
        }
        return DownloadService.downloadInvoice(invoice[`${type}_path`], invoice.category.id_account)
    }

    // DL LINK
    $scope.dlInvoice = (invoice, meta, e) => {
        e.preventDefault()
        e.stopPropagation()
        return DownloadService.downloadInvoice(invoice.download_link, meta.category.id_account)
    }

    $scope.launchOperationModal = () => ModalService.openModal({ type: 'launchOperationModal', size: 'md', backdrop: 'static' })

    $scope.refreshInvoices = () => {
        TableGeneratorService.getTable(
            $scope.metaInvoices,
            'meta-invoices-light',
            `category.account`,
            null,
            {
                orderBy: '-id',
                in: clientMode ? ['status=50,75'] : [],
            },
        )
    }

    $scope.toggleProcessed = (invoice) => {
        invoice.toggling = true
        return DataAccess.toggleProcessedMeta({ id: invoice.id }, {}).$promise.then((result) => {
            AlertManager.success(`Status mis à jour : "${result.external_status}"`)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            invoice.toggling = false
        })
    }

    // MASS OPERATIONS

    // MASS VALUATE
    $scope.massValuateTemplate = {
        reprocessAll: false,
    }

    $scope.massValuateFields = {
        reprocessAll: {
            label: 'Relancer toutes les valo. des sous-factures',
            type: 'checkbox',
        },
    }

    $scope.massValuate = () => {
        const invoices = $scope.getValuables()
        if (!invoices.length) {
            return
        }
        return ApiBilling.batchValuateMetaInvoice({ invoices, reprocessAll: $scope.massValuateTemplate.reprocessAll }).$promise.then((result) => {
            AlertManager.success(`Valorisation en masse lancée sur : ${result.number} factures.`)
        })
        .catch(ErrorCatcher)
    }

    // MASS SIMULATE
    $scope.massSimulateTemplate = {
        regen: false,
    }

    $scope.massSimulateFields = {
        regen: {
            label: 'Regénérer tous les PDF des sous-factures',
            type: 'checkbox',
        },
    }

    $scope.massSimulate = () => {
        const simulableCompensations = $scope.getSimulableCompensations()
        const simulableNotCompensations = $scope.getSimulableNotCompensations()
        if (!simulableCompensations.length && !simulableNotCompensations.length) {
            return
        }
        $scope.massSimulating = true
        return Promise.resolve().then(() => {
            if (simulableNotCompensations.length) {
                return ApiBilling.batchSimulateMetaInvoice({ invoices: simulableNotCompensations, regen: $scope.massSimulateTemplate.regen }).$promise.then((result) => {
                    AlertManager.success(`Simulation en masse lancée sur : ${result.number} factures.`)
                })
                .catch(ErrorCatcher)
            }
        })
        .then(() => {
            if (simulableCompensations.length) {
                return Sequentializer.mapSeries(
                    simulableCompensations,
                    (invoiceId) => ApiBilling.simulateCompensationsMeta({ id_meta_invoice: invoiceId }, {}).$promise
                    .then(() => {
                        AlertManager.success(`Simulation lancée sur la rétribution ${invoiceId}.`)
                    })
                    .catch(ErrorCatcher),
                )
            }
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.massSimulating = false
            $scope.refreshInvoices()
        })
    }

    // MASS RUN
    $scope.massRunTemplate = {
        regen: false,
        andSend: true,
    }

    $scope.massRunFields = {
        regen: {
            label: 'Regénérer tous les PDF des sous-factures',
            type: 'checkbox',
        },
        andSend: {
            label: 'Et envoyer automatiquement à CHORUS',
            type: 'checkbox',
        },
    }

    $scope.massRun = () => {
        const simulableCompensations = $scope.getSimulableCompensations()
        const simulableNotCompensations = $scope.getSimulableNotCompensations()
        if (!simulableCompensations.length && !simulableNotCompensations.length) {
            return
        }
        $scope.massRunning = true
        return Promise.resolve().then(() => {
            if (simulableNotCompensations.length) {
                return ApiBilling.batchRunMetaInvoice({ invoices: simulableNotCompensations, regen: $scope.massRunTemplate.regen, andSend: $scope.massRunTemplate.andSend }).$promise.then((result) => {
                    AlertManager.success(`Lancement en masse lancé sur : ${result.number} factures`)
                })
                .catch(ErrorCatcher)
            }
        })
        .then(() => {
            if (simulableCompensations.length) {
                return Sequentializer.mapSeries(
                    simulableCompensations,
                    (invoiceId) => ApiBilling.runCompensationsMeta({ id_meta_invoice: invoiceId }, {}).$promise
                    .then(() => {
                        AlertManager.success(`Rétribution ${invoiceId} lancée.`)
                    })
                    .catch(ErrorCatcher),
                )
            }
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.massRunning = false
            $scope.refreshInvoices()
        })
    }

    // MASS DONE
    const openMassDoneResultModal = (result) => ModalService.openModal({ type: 'resultModal', size: 'lg' }, { result })

    $scope.massReversalDone = () => {
        const invoices = $scope.getReversalDoneables()
        if (!invoices.length) {
            return
        }
        const invoiceIds = _.map(invoices, (i) => i.id)
        $scope.doneing = true
        $scope.massReversalDoneing = true
        return ApiUser.invoiceReversalMassDone({ invoiceIds }).$promise
        .then((res) => {
            openMassDoneResultModal(res)
        })
        .catch((err) => {
            ErrorCatcher(err)
        })
        .finally(() => {
            $scope.doneing = false
            $scope.massReversalDoneing = false
            $scope.refreshInvoices()
        })
    }

    $scope.massDone = () => {
        const invoices = $scope.getDoneables()
        if (!invoices.length) {
            return
        }
        const invoiceIds = _.map(invoices, (i) => i.id)
        $scope.doneing = true
        $scope.massDoneing = true
        return ApiUser.invoiceMassDone({ invoiceIds }).$promise
        .then((res) => {
            openMassDoneResultModal(res)
        })
        .catch((err) => {
            ErrorCatcher(err)
        })
        .finally(() => {
            $scope.doneing = false
            $scope.massDoneing = false
            $scope.refreshInvoices()
        })
    }

    // MASS SEND
    $scope.massSendTemplate = {
        asis: false,
        skipDetails: false,
    }

    $scope.massSendFields = {
        asis: {
            hidden: (t) => t.skipDetails,
            label: 'Ne pas recalculer les montants pour CHORUS',
            type: 'checkbox',
        },
        skipDetails: {
            hidden: (t) => t.asis,
            label: 'Ne pas envoyer les lignes de TVA',
            type: 'checkbox',
        },
    }

    $scope.massSend = () => {
        const invoices = $scope.getSendablesInvoices()
        if (!invoices.length) {
            return
        }
        $scope.massSending = true
        _.each(invoices, (i) => {
            i.asis = $scope.massSendTemplate.asis
            i.skipDetails = $scope.massSendTemplate.skipDetails
        })
        return Sequentializer.mapSeries(invoices, (invoice) => $scope.sendToChorus(invoice, true))
        .then((result) => {
            console.log(`Send result`, result)
            AlertManager.success(`Factures envoyées`)
        })
        .finally(() => {
            $scope.massSending = false
            $scope.refreshInvoices()
        })
    }

    // MASS REVERT
    $scope.massRevertTemplate = {
        expectedChorusStatus: 'REJETEE',
    }

    $scope.massRevertFields = {
        expectedChorusStatus: {
            label: 'Statut CHORUS attendu (protection anti-bêtise)',
            type: 'text',
        },
    }

    $scope.massRevert = () => {
        const invoices = $scope.getReversables()
        if (!invoices.length) {
            return
        }
        return ApiBilling.batchRevertMetaInvoice({ invoices, expectedChorusStatus: $scope.massRevertTemplate.expectedChorusStatus }).$promise.then((result) => {
            AlertManager.success(`Extourne en masse lancé sur : ${result.number} factures`)
        })
        .catch(ErrorCatcher)
    }

    // MASS CANCEL
    $scope.massCancel = () => {
        const invoices = $scope.getCancellablesInvoices()
        if (!invoices.length) {
            return
        }
        $scope.massCancelling = true
        return Sequentializer.mapSeries(invoices, (invoice) => $scope.cancelInvoice(invoice, true))
        .then((result) => {
            console.log(`Mass cancel result`, result)
            AlertManager.success(`Factures annulées`)
        })
        .finally(() => {
            $scope.massCancelling = false
            $scope.refreshInvoices()
        })
    }

    // MASS PENALTY
    $scope.massPenalty = () => {
        const invoices = $scope.getPenaltyablesInvoices()
        if (!invoices.length) {
            return
        }
        $scope.massPenaltying = true
        return Sequentializer.mapSeries(invoices, (invoice) => $scope.createPenalty(invoice, true))
        .then((result) => {
            console.log(`Mass penalty result`, result)
            AlertManager.success(`Pénalités créées`)
        })
        .finally(() => {
            $scope.massPenaltying = false
            $scope.refreshInvoices()
        })
    }

    // MASS SYNCH CHORUS
    $scope.massSynchChorus = () => {
        const invoices = $scope.getReversables()
        if (!invoices.length) {
            return
        }
        return ApiUser.massCheckChorusStatus({ invoices }).$promise.then((result) => {
            AlertManager.success(`Synchro lancée sur : ${result.number} factures`)
        })
        .catch(ErrorCatcher)
    }

    // tools (out of prod)
    $scope.synchroFields = {
        warning: {
            type: 'label',
            label: `<span class="red">Attention, merci de s'assurer qu'il n'y a aucun traitement de facture en cours avant de lancer la synchro !</span>`,
        },
    }

    $scope.synchroMetaInvoiceNumberWithOdoo = () => {
        if (!$scope.showTools) {
            AlertManager.error(`Impossible de lancer cette opération sur cet environnement`)
            return
        }
        $scope.synchronizingMetaInvoiceNumberWithOdoo = true
        return ApiAdmin.synchroMetaInvoiceNumberWithOdoo().$promise
        .then((result) => {
            AlertManager.success(`Synchro effectuée !`)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.synchronizingMetaInvoiceNumberWithOdoo = false
        })
    }

    $scope.fetchPrepResult = (invoice) => DataAccess.getMetaPrepResult({ id: invoice.id })

    $scope.refreshInvoices()

    $scope.getNbMessages = () => {
        ApiBilling.getMessagesNumber().$promise.then((result) => {
            $scope.nbMessages = result
        })
        .catch(ErrorCatcher)
    }

    if (!$scope.clientMode) {
        $scope.getNbMessages()
    }
})
